import DateChanged from "./DateChanged"
import DateChangedByRol from "./DateChangedByRol"
import DocumentRecordStaff from "./DocumentRecordStaff"
import EightAssesmentScore from "./EightAssesmentScore"
import FormLength from "./FormLength"
import HiddenDefault from "./HiddenDefault"
import IntakeId from "./IntakeId"
import OrganizationId from "./OrganizationId"
import ParticipantId from "./ParticipantId"
import ParticipantUserChanged from "./ParticipantUserChanged"
import SessionId from "./SessionId"
import SessionLength from "./SessionLength"
import SupervisionPlanChange from "./SupervisionSessionPlanChange"
import SupervisionStaffMembership from "./SupervisionStaffMembership"
import ParticipantServices from "./ParticipantServices"

export default function TypeHidden(props) {
  switch (props.field.field_name) {
    case "assessment_8d_score":
      return <EightAssesmentScore {...props} />
    case "date_changed":
      return <DateChanged {...props} />
    case "date_modified_partner":
      return <DateChangedByRol {...props} />
    case "date_modified_staff":
      return <DateChangedByRol {...props} />
    case "document_record_staff_id":
      return <DocumentRecordStaff {...props} />
    case "form_length":
      return <FormLength {...props} />
    case "intake_id":
      return <IntakeId {...props} />
    case "organization_id":
      return <OrganizationId {...props} />
    case "participant_id":
      return <ParticipantId {...props} />
    case "participant_user_changed":
      return <ParticipantUserChanged {...props} />
    case "session_id":
      return <SessionId {...props} />
    case "session_length":
      return <SessionLength {...props} />
    case "supervision__staff_membership_id":
      return <SupervisionStaffMembership {...props} />
    case "supervision_session_plan_change":
      return <SupervisionPlanChange {...props} />
    case "participant_services":
      return <ParticipantServices {...props} />
    default:
      return <HiddenDefault {...props} />
  }
}
